<template>
  <div class="container">
    <table class="score-table">
      <tr>
        <th v-for="h in headers" :key="h.key" :style="h.width ? `width:${h.width}` : ''" class="table-header">
          {{ h.label }}
        </th>
      </tr>
      <tr v-for="p in numPlayers" :key="p">
        <td v-for="h in headers" :key="h.key">
          <div class="player-name-input-container" v-if="h.key === 'player'">
            <div v-if="$route.name !== 'result'">
              <input type="text" :class="{
                'player-name-input': true,
                'player-on-direct':
                  ['ShowAnswer', 'Question', 'Answer'].includes(
                    questionDisplayMode
                  ) &&
                  getCurrent.player === getPlayers[p - 1].id &&
                  !finishGame,
                'seat-empty': getPlayers[p - 1].emptySeat,
              }" v-model="getPlayers[p - 1].name" :placeholder="getPlayers[p - 1].placeholder" :disabled="leagueMatch"
                maxlength="50" />
              <font-awesome-icon v-if="!getPlayers[p - 1].emptySeat" icon="fa-solid fa-square-minus"
                class="empty-seat-button" @click="toggleEmpty(getPlayers[p - 1].id)" />
              <font-awesome-icon v-if="getPlayers[p - 1].emptySeat" icon="fa-solid fa-square-plus"
                class="empty-seat-button" @click="toggleEmpty(getPlayers[p - 1].id)" />
            </div>
            <div v-else>
              <div
                :class="{ 'player-name-input': true, 'seat-empty': getPlayers[p - 1].emptySeat || !getPlayers[p - 1].name }">
                {{ getPlayers[p - 1].name || getPlayers[p - 1].placeholder }}
              </div>
            </div>
          </div>
          <div class="scores-ba scores-points" v-if="h.key === 'correct'">
            {{ getScores.totalCorrect[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'bonusAttempts'">
            {{ getScores.bonusAttempts[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'owns'">
            {{ `${getScores.owns[p - 1][0]}/${getScores.owns[p - 1][1]}` }}
          </div>
          <div class="scores-ba" v-if="h.key === 'bonusPoints'">
            {{ getScores.bonusPoints[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'notAnswered'">
            {{ getScores.notAnswered[p - 1] }}
          </div>
          <div class="scores-ba" v-if="h.key === 'roundSummary'">
            {{
              `${getScores.roundSummary[p - 1][0]},${getScores.roundSummary[p - 1][1]
              },${getScores.roundSummary[p - 1][2]}`
            }}
          </div>
          <div class="scores-ba" v-if="h.key === 'previousSummary'">
            {{
              `${getScores.previousSummary[p - 1][0]},${getScores.previousSummary[p - 1][1]
              },${getScores.previousSummary[p - 1][2]}`
            }}
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "ScorerTable",
  computed: {
    ...mapGetters(["getPlayers", "getScores", "getCurrent"]),
    ...mapState(["numPlayers", "questionDisplayMode", "finishGame", "leagueMatch"]),
  },

  data() {
    return {
      headers: [
        {
          label: "Players",
          key: "player",
        },
        {
          label: "Pts",
          width: "9%",
          key: "correct",
        },
        {
          label: "BAs",
          width: "9%",
          key: "bonusAttempts",
        },
        {
          label: "Owns",
          width: "9%",
          key: "owns",
        },
        {
          label: "BPts",
          width: "9%",
          key: "bonusPoints",
        },
        {
          label: "Xs",
          width: "9%",
          key: "notAnswered",
        },
        {
          label: "rPOX",
          width: "9%",
          key: "roundSummary",
        },
        {
          label: "pPOX",
          width: "9%",
          key: "previousSummary",
        },
      ],
    };
  },

  methods: {
    ...mapActions(["toggleEmpty"]),
  },
};
</script>

<style scoped>
.container {
  display: flex;
}

.score-table {
  width: 100%;
}

.table-header {
  font-size: 2.75vmin;
  height: 40px;
  background-color: #d7d7d7;
}

.score-table {
  flex: 16 16 auto;
}

.player-name-th {
  width: 20%;
}

.scores-ba {
  background-color: #fdfcf6;
  border: none;
  text-align: center;
  font-family: Nunito;
  font-size: 2.5vmin;
  width: 100%;
}

.scores-points {
  font-size: 2.75vmin;
  font-weight: bold;
}

.player-name-input {
  background-color: #fdfcf6;
  border: 2px solid gray;
  border-radius: 2px;
  font-weight: bold;
  font-family: Nunito;
  width: 100%;
  padding: 5px;
  font-size: 2.5vmin;
  text-align: center;
  box-sizing: border-box;
}

.player-name-input::placeholder {
  font-weight: normal;
  color: #696969;
}

.player-on-direct {
  background-color: #f2dfb6;
  border: 3px solid #333333;
}

.player-name-input-container {
  position: relative;
}

.empty-seat-button {
  position: absolute;
  right: 0.5vmin;
  top: 0.5vmin;
  height: 2vmin;
  color: #5f5f5f;
  cursor: pointer;
}

.empty-seat-button:hover {
  color: rgb(135, 135, 135);
}

.seat-empty {
  opacity: 0.3;
}
</style>